export const selectAllAuthorizations = state => state.authorization.authorizations
export const selectActiveAuth = state => state.authorization.active
